"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorialPageContainer = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _EditorialPage = require("../components/EditorialPage");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component that wraps `EditorialPage` with relevant Providers (TestIdProvider, ThemeProvider, TranslationsProvider).
 */ const EditorialPageContainer = (param)=>{
    let { breadcrumbs, data, productBoxConfiguration, className, atpClusterId, customerTypeId, preview } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _constants.APP_TEAM_NAME,
        project: _constants.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "EditorialPageContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                        namespace: _constants.translationsNamespace,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
                            atpClusterId: atpClusterId,
                            customerTypeId: customerTypeId,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_EditorialPage.EditorialPage, {
                                breadcrumbs: breadcrumbs,
                                data: data,
                                productBoxConfiguration: productBoxConfiguration,
                                className: className,
                                preview: preview
                            })
                        })
                    })
                })
            })
        })
    });
};
exports.EditorialPageContainer = EditorialPageContainer;
